module.exports = __webpack_public_path__ + "images/fifth_anniversary_modal/modal-title_dcabffa6a50ab652f4f5f8c8267257a3.png";